import {
  FETCH_ADMIN_SHARED_TENANT_DETAIL_REQUEST,
  FETCH_ADMIN_SHARED_TENANT_DETAIL_SUCCESS,
  FETCH_ADMIN_SHARED_TENANT_DETAIL_FAILURE,
  CLEAR_ADMIN_SHARED_TENANT_DETAIL,
} from '../../../../Constants/actionTypes';
import { getAdminSharedTenantDetail } from '../../../../Constants/apiService';
import {
  getAdminTenantId,
  normalizeAdminTenantDetail,
} from '../../../../../Pages/Dashboard/Admin/Tenants/adminTenantMappers';
import { enrichTenantWithItsmUrl } from '../../../../../Pages/Dashboard/Admin/Tenants/tenantHelpers';

const getDetailErrorMessage = (error) => {
  const status = error?.status;

  if (status === 404) return 'Tenant could not be found.';
  if (status === 400) return error?.message || 'Invalid tenant request.';
  if (status === 401 || status === 403) {
    return error?.message || 'You do not have permission to view this tenant.';
  }
  if (status >= 500) return 'Unable to load tenant details.';
  if (error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')) {
    return 'Unable to load tenant details.';
  }

  return error?.message || 'Unable to load tenant details.';
};

export const fetchAdminSharedTenantDetailRequest = (requestKey) => ({
  type: FETCH_ADMIN_SHARED_TENANT_DETAIL_REQUEST,
  payload: { requestKey },
});

export const fetchAdminSharedTenantDetailSuccess = (tenant, requestKey) => ({
  type: FETCH_ADMIN_SHARED_TENANT_DETAIL_SUCCESS,
  payload: { tenant, requestKey },
});

export const fetchAdminSharedTenantDetailFailure = (error, requestKey) => ({
  type: FETCH_ADMIN_SHARED_TENANT_DETAIL_FAILURE,
  payload: { error, requestKey },
});

export const clearAdminSharedTenantDetailAct = () => ({
  type: CLEAR_ADMIN_SHARED_TENANT_DETAIL,
});

export const fetchAdminSharedTenantDetailAct = (tenantType, tenantNumber) => async (dispatch, getState) => {
  const requestKey = `${tenantType}-${tenantNumber}`;
  dispatch(fetchAdminSharedTenantDetailRequest(requestKey));

  const accessToken = getState()?.auth?.accessToken;

  try {
    const data = await getAdminSharedTenantDetail(accessToken, tenantType, tenantNumber);
    const tenant = enrichTenantWithItsmUrl(normalizeAdminTenantDetail(data?.tenant || {}));
    dispatch(fetchAdminSharedTenantDetailSuccess(tenant, requestKey));
    return tenant;
  } catch (error) {
    dispatch(fetchAdminSharedTenantDetailFailure(getDetailErrorMessage(error), requestKey));
    return null;
  }
};

export const getAdminSharedTenantDetailRequestKey = (tenant) => (
  tenant ? getAdminTenantId(tenant) : ''
);
